/**
 * rehype plugin for streaming answers: wraps every word in `<span class="tw">` so
 * it settles in with a soft blur (see `.tw` in index.css). React keys follow
 * element positions, so words already on screen keep their DOM nodes and only
 * newly streamed words animate. Code, and citation chips are left untouched.
 */

type HastNode = {
  type: string
  tagName?: string
  value?: string
  properties?: Record<string, unknown>
  children?: HastNode[]
}

const SKIP = new Set(['pre', 'code', 'cite', 'script', 'style'])
const WHITESPACE = /^\s+$/

function wrap(node: HastNode): void {
  if (!node.children) return
  if (node.type === 'element' && node.tagName && SKIP.has(node.tagName)) return
  const next: HastNode[] = []
  for (const child of node.children) {
    if (child.type === 'text' && child.value) {
      for (const part of child.value.split(/(\s+)/)) {
        if (!part) continue
        if (WHITESPACE.test(part)) next.push({ type: 'text', value: part })
        else
          next.push({
            type: 'element',
            tagName: 'span',
            properties: { className: ['tw'] },
            children: [{ type: 'text', value: part }],
          })
      }
    } else {
      wrap(child)
      next.push(child)
    }
  }
  node.children = next
}

export function rehypeWordReveal() {
  return (tree: HastNode) => {
    wrap(tree)
  }
}
